import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppSvgIconComponent } from "@vallift/ngl";

@Component({
  selector: 'app-home-device-section',
  templateUrl: './home-device-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AppSvgIconComponent],
})
export class HomeDeviceSectionComponent {}
